
import api  from "../api"


export default{
  
  async getDutyList({state,commit}){
    let list =  await api.channelApi.getChannel({parentId:166})
    let arr=[]
    list.data.forEach(item=>{
      arr.push({name:item.name,id:item.id});
    })
    arr.unshift({name:"全部",id:""});
    commit('updateDutyList',arr)
  },

  async getWardList({state,commit}){
    let list =  await api.channelApi.getChannel({parentId:334})
    let arr=[]
    list.data.forEach(item=>{
      arr.push({name:item.name,id:item.name});
    })
    arr.unshift({name:"全部",id:""});
    commit('updateWardList',arr)
  },
  
  async getLevelList({state,commit}){
    let list = await api.channelApi.getChannel({parentId:190})
    let newList=[];
    list.data.forEach(item=>{
      newList.push({name:item.name,id:item.id})
    })
    newList.unshift({name:"全部",id:-1})
    commit("updateLevelLity",newList)
  },

  async getAbout({state,commit}){
    let content = await api.aboutApi.homeAbout();
    commit("updateAboutContent",content.data.about_content)
  },

  async getActivityCate({state,commit}){
    let res = await api.channelApi.getChannel({parentId:700})
    let list = res.data || []
    list.unshift({name:"全部",id:-1})
    commit("updateList",{
      name:'activityCate',
      list:list
    })
  },

  async getPosterCate({state,commit}){
    let res = await api.channelApi.getChannel({parentId:700})
    let list = res.data || []
    list.unshift({name:"全部",id:-1})
    commit("updateList",{
      name:'posterCate',
      list:list
    })
  }


}